/* Shared boxed-PDP cart composition. Keep device substitutions and Complete grouping in one place. */
(() => {
  const purchase = {
    getSelectedCartItems(variant = this.getSelectedVariant(), { bundleId: selectedBundleId = this._selectedBundleId, addonIds = this._selectedAddonIds, substitutions = [], omissions = [], addedItems = [], requiredUnderskinAdded = false } = {}) {

      if (!variant) {
        return [];
      }

      const selectedBundle = variant.bundles.find(
        (bundle) => bundle.id === selectedBundleId
      );
      const essentialBundle = this.getEssentialBundle(variant);
      const variantIds = new Set([
        variant.id,
        ...(this._cartConfigurationExact ? [] : essentialBundle?.variantIds || []),
      ].filter(Boolean).map((id) => String(id)));

      if (selectedBundle) {
        selectedBundle.variantIds.forEach((id) => variantIds.add(String(id)));
      } else {
        this.getBundleItems(variant)
          .filter((item) => addonIds.has(this.getAddonId(item)))
          .filter((item) => item.variantId)
          .forEach((item) => variantIds.add(String(item.variantId)));
      }

      this.getBundleItems(variant)
        .filter((item) => !this.shouldAddBundleItemToCart(item))
        .forEach((item) => variantIds.delete(String(item.variantId)));

      const cartItems = Array.from(variantIds)
        .filter(Boolean)
        .map((id) => ({
          id: Number(id),
          quantity: 1,
        }));
      const equivalentNotes = substitutions.map(({ requested, added }) => this.dataset.deviceEquivalentNoteTemplate
        .replace('__requested__', requested)
        .replace('__added__', added)
        .replace('__device__', variant.deviceTitle || ''));
      omissions.forEach((requested) => equivalentNotes.push(this.dataset.deviceOmittedNoteTemplate
        .replace('__requested__', requested)
        .replace('__device__', variant.deviceTitle || '')));
      addedItems.forEach((added) => equivalentNotes.push(this.dataset.deviceIncludedNoteTemplate
        .replace('__added__', added)
        .replace('__device__', variant.deviceTitle || '')));
      if (requiredUnderskinAdded) {
        equivalentNotes.push(this.dataset.deviceRequiredUnderskinNoteTemplate
          .replace('__device__', variant.deviceTitle || ''));
      }
      if (equivalentNotes.length) {
        const parent = cartItems.find((item) => String(item.id) === String(variant.id));
        if (parent) parent.properties = { _marmelade_device_equivalent_note: equivalentNotes.join('\n') };
      }
      const bundleVisualizationEnabled = true;
      const hasSelectedAddon = this.getOptionalItems(variant).some((item) => (
        addonIds.has(this.getAddonId(item))
        && item.variantId
        && this.shouldAddBundleItemToCart(item)
      ));
      const isCustomBundle = selectedBundleId === 'custom' && hasSelectedAddon;

      if (
        !bundleVisualizationEnabled
        || cartItems.length <= 1
        || (!selectedBundle && !isCustomBundle)
      ) {
        return cartItems;
      }

      const bundleId = typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const bundleTitle = isCustomBundle
        ? this.dataset.customBundleTitle
        : selectedBundle.displayTitle || selectedBundle.title || '';
      const bundleDiscountValue = isCustomBundle
        ? 0
        : Number(selectedBundle.discountValue || 0);
      const bundleDiscountType = selectedBundle?.discountTypeFlat ? 'flat' : 'percentage';
      const actualIds = new Set(cartItems.map((item) => String(item.id)));
      const completeIds = new Set([
        String(variant.id),
        ...this.getEssentialItems(variant),
        ...(selectedBundle?.contents || []),
      ].filter((item) => typeof item === 'string' || this.shouldAddBundleItemToCart(item))
        .map((item) => typeof item === 'string' ? item : String(item.variantId))
        .filter(Boolean));
      const completeIphoneBundle = variant.isIphoneDevice
        && String(selectedBundle?.displayTitle || selectedBundle?.title || '').toLocaleLowerCase() === 'complete'
        && actualIds.size === cartItems.length && actualIds.size === completeIds.size
        && [...completeIds].every((id) => actualIds.has(id));

      return cartItems.map((item) => ({
        ...item,
        properties: {
          ...item.properties,
          ...(completeIphoneBundle ? { _bundleUniqueId: bundleId, _bundleItemSize: '1' } : {}),
          _marmelade_bundle_id: bundleId,
          _marmelade_bundle_title: bundleTitle,
          _marmelade_bundle_parent: String(item.id) === String(variant.id) ? 'true' : 'false',
          _marmelade_bundle_discount_type: bundleDiscountType,
          _marmelade_bundle_discount_value: String(bundleDiscountValue),
        },
      }));
    }
  };
  if (typeof module !== "undefined" && module.exports) module.exports = purchase;
  if (typeof window !== "undefined") window.MarmeladeProductPurchase = purchase;
})();
